import { removeHTMLTags } from '@jusbrasil-web/docview/core'
import { organization, siteNavigation, website } from '@jusbrasil-web/shared-utils-seo'

import { MotionMetaTags_DocumentFragment } from './__generated__/motion-meta-tags.graphql'

const MAX_DESCRIPTION = 155

export class MotionSeoMetadata {
  private readonly document

  constructor(document: MotionMetaTags_DocumentFragment) {
    this.document = document
  }

  private getTitle() {
    const { lawsuitNumber = '', title = '' } = this.document
    if (lawsuitNumber) {
      const lawsuitNumberCropped = lawsuitNumber.slice(11)
      return `${title} - ${lawsuitNumberCropped} | Jusbrasil`
    }

    return `${title} | Jusbrasil`
  }

  private getDescription() {
    const { lawsuit, text } = this.document
    const { court, subjects = [] } = lawsuit || {}

    const fallbackDescription = `${removeHTMLTags(text || '').substring(0, MAX_DESCRIPTION)}`
    if (!court && !subjects.length) {
      return fallbackDescription
    }

    const descriptionItems = ['Peça processual']
    if (court) {
      descriptionItems.push(` do ${court}`)
    }
    if (subjects.length) {
      const parsedSubjects = subjects.join(', ')
      descriptionItems.push(` sobre ${parsedSubjects}`)
    }
    descriptionItems.push('.')

    return descriptionItems.join('').substring(0, MAX_DESCRIPTION)
  }

  private getStructuredDataItems() {
    const { meta } = this.document

    return {
      article: {
        ...meta,
        alternativeHeadline: meta?.headline ? `${meta?.headline} em Peças Processuais` : null,
        alternateName: meta?.headline || null,
      },
    }
  }

  private buildSeoMetadata() {
    const { noIndex } = this.document

    const title = this.getTitle()
    const description = this.getDescription()
    const { article } = this.getStructuredDataItems()

    return {
      title,
      description,
      keywords: [],
      structuredData: {
        '@context': 'https://schema.org',
        '@graph': [organization, website, siteNavigation, article].filter(Boolean),
      },
      noIndex,
    }
  }

  getSeoMetadata() {
    return this.buildSeoMetadata()
  }
}
